"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterRoutesByValue = exports.filterOptionsFn = exports.getSelectedRouteNameValue = exports.defaultTextAndValue = void 0;
exports.defaultTextAndValue = {
    text: '',
    value: '',
    name: ''
};
exports.getSelectedRouteNameValue = function (routes, selectedRouteId) {
    if (routes) {
        var matchedRoute = routes.find(function (data) { return data.value === selectedRouteId; });
        if (matchedRoute) {
            return matchedRoute;
        }
    }
    return exports.defaultTextAndValue;
};
exports.filterOptionsFn = function (matchCase) { return function (value) { return function (singleOption) {
    var regExpFlag = matchCase ? undefined : 'i';
    var matchRegExp = new RegExp(value, regExpFlag);
    var matchedRes = singleOption.text.match(matchRegExp);
    var res = matchedRes && matchedRes.length > 0;
    return res;
}; }; };
exports.filterRoutesByValue = function (matchCase) { return function (value, routes) {
    var filtered = routes.filter(exports.filterOptionsFn(matchCase)(value));
    return value.length === 0 ? routes : filtered;
}; };
